"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const HelperUtils_1 = require("utils/HelperUtils");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const defaultProps = {
    text: 'No options selected',
    type: 'auto',
    label: 'Dropdown',
    topLabel: true,
    icon: 'icon-avatar'
};
const WrapperCN = ({ type, customWrapperClass, disabled }) => {
    return (0, classnames_template_literals_1.default)(`
    ${type == 'auto' ? 'inline-flex' : 'flex'}
    flex-col
    cursor-pointer
    ${customWrapperClass}
    ${disabled ? '!bg-n-300 text-n-600 cursor-not-allowed' : 'bg-n-000'}
    h-[32px]
  `);
};
const TriggerCN = () => {
    return (0, classnames_template_literals_1.default)(`
    flex
    border
    border-n-400
    border-solid
    py-[6px]
    pl-[16px]
    pr-[8px]
    rounded-md
    justify-between
    items-center
    h-full
  `);
};
const TextCN = ({ wrapText, capitalize, customTextClass }) => {
    return (0, classnames_template_literals_1.default)(`
    ${!wrapText && 'truncate text-n-900'}
    ${capitalize && 'capitalize'}
    ${customTextClass}
  `);
};
const Trigger = ({ iconName, text, type, topLabel, label, icon, onClick, customWrapperClass, customTextClass, textStyle, disabled, wrapText = false, capitalize = false, iconFillColor, dataCy }) => {
    return (react_1.default.createElement("div", { className: WrapperCN({ type, customWrapperClass, disabled }), "data-cy": dataCy },
        topLabel && (react_1.default.createElement("label", { className: "typography-h100 text-n-800 mb-[8px]" }, label)),
        react_1.default.createElement("div", { className: TriggerCN(), onClick: onClick },
            react_1.default.createElement("div", { className: "flex items-center", style: wrapText ? {} : { width: 'calc(100% - 24px)' } },
                icon && (react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: iconFillColor ? iconFillColor : 'var(--n-600)', iconName: icon, customClass: "mr-[8px]" })),
                react_1.default.createElement("p", { className: TextCN({ wrapText, capitalize, customTextClass }), style: textStyle },
                    !topLabel && label && (react_1.default.createElement("span", { className: "typography-h400" }, `${label}: `)),
                    (0, HelperUtils_1.getObjectiveLocale)(text))),
            react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: iconFillColor ? iconFillColor : 'var(--n-800)', iconName: iconName ? iconName : 'icon-dropdown-caret' }))));
};
Trigger.defaultProps = defaultProps;
exports.default = Trigger;
